export default {"src":"/_next/static/media/light.7a3cbafc.svg","height":97,"width":677,"blurWidth":0,"blurHeight":0};